export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"], // add more scopes if needed
};
